function Header() {
    return (
      <b>This is Header Demo</b>
    );
  }
  
  export default Header;
  